/** Presentation mode for the shared verification screens (regular vs compact). */
export type PresentationMode = 'regular' | 'compact';

export interface PresentationTokens {
  /** Whether the brand logo / branding zone is rendered. */
  showLogo: boolean;
  /** Omni `FlexContainer`/`Container` spacing key for the outer screen padding. */
  screenPadding: 'large' | 'medium';
  /** Horizontal inset (px) for headers, titles, and body copy. */
  edgePaddingPx: number;
  /** Vertical padding (px) for header blocks. */
  blockPaddingPx: number;
}

/** Presentation values per mode. */
export const PRESENTATION_TOKENS: Record<PresentationMode, PresentationTokens> =
  {
    regular: {
      showLogo: true,
      screenPadding: 'large',
      edgePaddingPx: 32,
      blockPaddingPx: 32,
    },
    compact: {
      showLogo: false,
      screenPadding: 'medium',
      edgePaddingPx: 16,
      blockPaddingPx: 16,
    },
  };

/** Available height (px) at or below which the app renders compact (absent an override). */
export const COMPACT_MAX_HEIGHT_PX = 640;
